import { render, staticRenderFns } from "./AutomationRules.vue?vue&type=template&id=12736259&scoped=true"
import script from "./AutomationRules.vue?vue&type=script&lang=js"
export * from "./AutomationRules.vue?vue&type=script&lang=js"
import style0 from "./AutomationRules.vue?vue&type=style&index=0&id=12736259&prod&lang=scss"
import style1 from "./AutomationRules.vue?vue&type=style&index=1&id=12736259&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12736259",
  null
  
)

export default component.exports